import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';
import '../css/Home.css';

function Home() {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    axios.get('/README.md')
      .then(response => {
        setMarkdown(response.data);
      })
      .catch(error => {
        console.error('Error loading markdown:', error);
        setMarkdown(`# Error loading content...

Error details:
- URL: ${error.config?.url}
- Status: ${error.response?.status}
- Message: ${error.message}

Please check:
1. README.md exists in the same location as check_nginx.txt
2. nginx configuration allows .md files
`);
      });
  }, []);

  const components = {
    h2: ({ node, children, ...props }) => (
      <h2
        style={{ display: 'block', marginTop: '2rem' }}
        {...props}
      >
        {children}
      </h2>
    ),
    ul: ({ node, ...props }) => (
      <ul style={{ marginBottom: '2rem' }} {...props} />
    )
  };

  return (
    <div className="page-container">
      <div className="markdown-container">
        <ReactMarkdown components={components}>{markdown}</ReactMarkdown>
      </div>
    </div>
  );
}

export default Home;